export type ExportFormat = 'csv' | 'xlsx';

// Export as a union type for type safety
export type StatType = 'creators' | 'contractors' | 'transport-orders-status' | 'profit';

// Polish translations for stat types
export const statTypeTranslations: Record<StatType, string> = {
    creators: 'Spedytorzy',
    contractors: 'Podwykonawcy',
    'transport-orders-status': 'Statusy zleceń',
    profit: 'Marża',
};